<div class="upload-modal">
  <div class="row">
    <h3>{{'LABELS.BEARER_TOKEN' | translate }}</h3>
  </div>
  <div class="row">
    <textarea rows="8" type="text" [(ngModel)]="token" name="token"></textarea>
  </div>
  <div class="row">
    <button class="buttonAccept" (click)="accept()">{{'BUTTONS.ACCEPT' | translate }}</button>
  </div>
</div>

